import { IVersion, ProfileRequest } from '@utils';
import { makeObservable, observable, action, computed, runInAction } from 'mobx';
import { Inject, Service } from 'typedi';

@Service()
export class VersionService {

  @Inject(() => ProfileRequest)
  private profileRequest: ProfileRequest;

  /**
   * Версия приложения
   */
  @observable.ref version: IVersion = {
    appVersion: {
      major: 0,
      sprint: 0,
      build: 0,
    },
    dbVersion: {
      major: 0,
      minor: 0,
    }
  };

  constructor() {
    makeObservable(this);
  }

  @computed get stringifyVersion() {
    return [`${this.version?.appVersion.major}.${this.version?.appVersion.sprint}.${this.version?.appVersion.build}`,
    `${this.version?.dbVersion.major}.${this.version?.dbVersion.minor}`,];
  }

  @action getVersion = () => {
    this.profileRequest.getVersion()
      .then((resp) => runInAction(() => this.version = resp.data));
  };
}
